import { CustomerAttribute } from '@msdyn365-commerce/retail-proxy';

export const getCustomerAttributeByName = (attributes: CustomerAttribute[] | undefined, name: string): CustomerAttribute | undefined => {
    if (!attributes?.length || !name) {
        return undefined;
    }

    return attributes.find(attribute => attribute.Name?.toUpperCase() === name.toUpperCase());
};

export const getCustomerAttributeStringValueByName = (attributes: CustomerAttribute[] | undefined, name: string): string => {
    const attribute = getCustomerAttributeByName(attributes, name);
    return attribute?.AttributeValue?.StringValue?.trim() || '';
};
